import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    cancelReasons: {
      selectIds: [],
      filters: {},
      selectId: false
    }
  },
  mutations: {
    SET_CANCELREASON_SELECT_IDS (store, ids) {
      store.cancelReasons.selectIds = ids
    },
    REMOVE_CANCELREASON_SELECT_IDS (store, ids) {
      store.cancelReasons.selectIds = store.cancelReasons.selectIds.filter((v) => { return !ids.includes(v) })
    },
    SET_CANCELREASON_SELECT_ID (store, id) {
      store.cancelReasons.selectId = id
    },
    SET_CANCELREASON_FILTERS (store, filters) {
      store.cancelReasons.filters = filters
    }
  },
  getters: {
    getCancelReasons: (store, getters) => {
      return store.cancelReasons.selectIds.map((id) => {
        return getters['entities/cancelReasons/find'](id)
      })
    },
    getCancelReasonsFilters: (store, getters) => {
      return store.cancelReasons.filters
    },
    getCancelReason: (store, getters) => {
      return getters['entities/cancelReasons/find'](store.cancelReasons.selectId) || {}
    }
  },
  actions: {
    /*
    selectCancelReasons
    */
    selectCancelReasons ({commit, dispatch, getters, state}, filters) {
      return dispatch('getCancelReasons', filters)
      .then((response) => {
        commit('SET_CANCELREASON_FILTERS', filters)
        commit('SET_CANCELREASON_SELECT_IDS', response.map((item) => { return item._id }))
        return response
      })
    },
    /*
    refreshSelectCancelReasons
    */
    refreshSelectCancelReasons ({commit, dispatch, getters, state}) {
      return dispatch('selectCancelReasons', getters.getCancelReasonsFilters)
    },
    /*
    selectCancelReason
    */
    selectCancelReason ({commit, dispatch, getters, state}, id) {
      return dispatch('getCancelReasonById', id)
      .then((response) => {
        commit('SET_CANCELREASON_SELECT_ID', response._id)
        return response
      })
    },
    /*
    getCancelReasons
    */
    getCancelReasons ({commit, dispatch, getters, state}, filters) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/cancel-reasons`, {params: filters})
      .then((response) => {
        return dispatch('entities/cancelReasons/insert', {
          data: response.data
        })
      })
      .then((result) => {
        return result.cancelReasons || []
      })
    },
    /*
    getCancelReasonById
    */
    getCancelReasonById ({commit, dispatch, getters, state}, id) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/cancel-reasons/${id}`)
      .then((response) => {
        return dispatch('entities/cancelReasons/insert', {
          data: response.data
        })
      })
      .then((result) => {
        return result.cancelReasons[0]
      })
    },
    /*
    createCancelReason
    */
    createCancelReason ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .post(`/accounts/${getters.getAccount._id}/cancel-reasons`, data)
      .then((response) => {
        return dispatch('entities/cancelReasons/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.cancelReasons[0]
      })
    },
    /*
    updateCancelReason
    */
    updateCancelReason ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${getters.getAccount._id}/cancel-reasons/${data._id}`, data)
      .then((response) => {
        return dispatch('entities/cancelReasons/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.cancelReasons[0]
      })
    },
    /*
    mergeCancelReasons
    */
    mergeCancelReasons ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${getters.getAccount._id}/cancel-reasons/merge`, data)
      .then((response) => {
        return dispatch('entities/cancelReasons/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.cancelReasons[0]
      })
    },
    /*
    deleteCancelReason
    */
    deleteCancelReason ({commit, dispatch, getters, state}, id) {
      return axios
      .delete(`/accounts/${getters.getAccount._id}/cancel-reasons/${id}`)
      .then((response) => {
        commit('REMOVE_CANCELREASON_SELECT_IDS', [id])
        dispatch('entities/cancelReasons/delete', id)
        return {}
      })
    }

  }
}



// WEBPACK FOOTER //
// ./src/store/CancelReason.js